// Reference getCardValue: K=13, Q=12, J=11, A=1, else the number (10 from a 4-char token)
export function card32Value(token) {
  let v = token.length === 4 ? token.slice(0, 2) : token.slice(0, 1);
  if (v === "K") v = 13;
  if (v === "Q") v = 12;
  if (v === "J") v = 11;
  if (v === "A") v = 1;
  return parseInt(v, 10) || 0;
}

/**
 * Reference dealing for 32 Cards (card32 / pcard32 / tcard32 / card32eu):
 * cards dealt round-robin to Player 8..11 ("1" = not dealt, the slot still advances);
 * each player's count starts at its number (8..11) plus the face values.
 */
export function card32Players(cardString) {
  const players = [8, 9, 10, 11].map((n) => ({ name: n, count: n, cards: [] }));
  String(cardString || "")
    .split(",")
    .map((c) => c.trim())
    .forEach((token, idx) => {
      if (token === "1" || token === "") return;
      const p = players[idx % 4];
      p.cards.push(token);
      p.count += card32Value(token);
    });
  return players;
}
